import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import PayPalPayment from "./PayPalPayment";

const paypalImg = require("./../assets/img/paypal.png");
const paypalImg2 = require("./../assets/img/graphic-paypal.png");
const cartIcon = require("./../assets/img/cart-icon3.svg").default;

const Payment = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const [shippingId] = useState(sessionStorage.getItem("FFFShippingId"));
  const [storeId] = useState(sessionStorage.getItem("FFFStoreId"));

  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [orderTotal, setOrderTotal] = useState(0);
  const [orderCurrency, setOrderCurrency] = useState("₹");
  const [paymentMethod, setPaymentMethod] = useState();
  const [paymentMethodList, setPaymentMethodList] = useState();
  const [signupStatus, setSignupStatus] = useState("");
  const [paypalCreds, setPaypalCreds] = useState();
  const isPaypalMethodAllowed = paymentMethodList?.includes("Paypal");
  const hasPaypalCredentials = !!(paypalCreds?.client_id && paypalCreds?.secret_key);
  const canUsePaypal = isPaypalMethodAllowed && hasPaypalCredentials && Number(orderTotal) > 0;
  // const [type,setType] = useState();
  // const [paymentProcess,setPaymentProcess] = useState('1');

  const resolveAmountAndCurrency = payload => {
    if (payload && typeof payload === "object") {
      const amount =
        payload.total ??
        0;
      const currency = payload.currency ?? "₹";
      return { amount, currency };
    }

    return { amount: payload ?? 0, currency: "₹" };
  };

  const fetchCartTotal = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}cart/amount/${storeId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        const { amount, currency } = resolveAmountAndCurrency(responseData.data);
        const parsedAmount = Number(amount);
        setOrderTotal(Number.isFinite(parsedAmount) ? parsedAmount : 0);
        setOrderCurrency(currency || "₹");
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const onPlaceOrder = async () => {
    if (!paymentMethod) {
      setSignupStatus(langJson?.pleasechoosePaymentMethod);
    } else {
      setLoadingBtn(true);
      try {
        const response = await fetch(`${API_BASE_URL}order`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
            shipping_id: shippingId,
            payment_method: paymentMethod,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          navigate("/order-success");
          sessionStorage.removeItem("FFFShippingId");
          sessionStorage.removeItem("FFFStoreId");
        } else {
          navigate("/payment-failed", { state: { message: responseData?.msg || langJson?.paymentfailed || "Payment failed" } });
        }
        setLoadingBtn(false);
      } catch (error) {
        navigate("/payment-failed", { state: { message: langJson?.paymentfailed || "Payment failed" } });
        setLoadingBtn(false);
      }
    }
  };

  const fetchPayments = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/${storeId}/payments`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        let tempArray = [];
        const clientId = responseData?.client_id ? String(responseData.client_id).trim() : "";
        const secretKey = responseData?.secret_key ? String(responseData.secret_key).trim() : "";
        if (clientId && secretKey) {
          setPaypalCreds({ client_id: clientId, secret_key: secretKey });
        } else {
          setPaypalCreds(null);
        }
        if (responseData.data.length > 0) {
          responseData.data.forEach(element => {
            tempArray.push(element.payment.title);
          });
          setPaymentMethodList(tempArray);
        } else {
          setPaymentMethodList([]);
        }
      } else {
      }
    } catch (error) { }
    // try {
    //   const response = await fetch(`${API_BASE_URL}frontend/payments`, {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${user.authorisation.token}`,
    //     },
    //   });
    //   const responseData = await response.json();
    //   if (responseData.res === true) {
    //     if (responseData.data?.length > 0) {
    //       let tempArray = [];
    //       responseData.data?.map(item => {
    //         tempArray.push(item?.title);
    //       });
    //       setPaymentMethodList(tempArray);
    //     }
    //   } else {
    //   }
    // } catch (error) {}
  };

  useEffect(() => {
    fetchCartTotal();
    fetchPayments();
    console.log(orderTotal, orderCurrency);
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="mainDiv">
        <div className="paymentDiv">
          <div className="mainDiv">
<div className="paymentInnerDiv">
            <ul>
              {orderTotal ? (
                <li>
                  <div className="payMntcart">
                    <img src={cartIcon} alt="" />{orderCurrency} {!loading ? (orderTotal ? orderTotal : 0) : ""}
                  </div>
                </li>
              ) : null}
              {paymentMethodList?.includes("Cash on delivery") ? (
                <li className="cashDelivery">
                  <input
                    name="paymentType"
                    type="radio"
                    value=""
                    onClick={() => {
                      setPaymentMethod("cash-on-delivery");
                      setSignupStatus("");
                    }}
                  />
                  {langJson?.cashondelivery}
                </li>
              ) : null}
              {paymentMethodList?.includes("Pre Payment") ? (
                <li className="cashDelivery">
                  <input
                    name="paymentType"
                    type="radio"
                    value=""
                    onClick={() => {
                      setPaymentMethod("pre-payment");
                      setSignupStatus("");
                    }}
                  />
                  {langJson?.prepayment}
                </li>
              ) : null}
              {paymentMethodList?.includes("As agreed") ? (
                <li className="cashDelivery">
                  <input
                    name="paymentType"
                    type="radio"
                    value=""
                    onClick={() => {
                      setPaymentMethod("as-agreed");
                      setSignupStatus("");
                    }}
                  />
                  {langJson?.asagreed}
                </li>
              ) : null}

              {paymentMethodList?.length === 0 ? <li className="cashDelivery">{langJson?.nopaymentmethodfound}</li> : null}

              <li>
                {loadingBtn ? <button disabled>{langJson?.pleasewait}</button> : <button onClick={() => onPlaceOrder()}>{langJson?.placeorder}</button>}
                {signupStatus ? <span className="lgnStatus">{signupStatus}</span> : null}
              </li>
              {canUsePaypal ? (
                <>
                  <span className="lgnStatus OrSpan">Or</span>
                  <div className="payPalDiv">
                    <PayPalPayment storeId={storeId} shippingId={shippingId} paymentMethod={"paypal"} productPrice={orderTotal} currency={orderCurrency} paypalCreds={paypalCreds} />
                  </div>
                </>
              ) : null}

              {isPaypalMethodAllowed && !hasPaypalCredentials ? (
                <li className="cashDelivery">{langJson?.paypaliscurrentlyunavailable || "PayPal is currently unavailable for this store."}</li>
              ) : null}

              {paymentMethodList?.length === 0 ? <li className="cashDelivery">{langJson?.nopaymentmethodfound}</li> : null}
            </ul>

            <div className="paymentRgt">
              <img src={paypalImg2} alt="" />
              <h3>{langJson?.newfastereasier}</h3>
              <p>{langJson?.welcometothenewpaypalcheckoutthesecurityyourelyonnowevenfaster}</p>
            </div>
</div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Payment;
